var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7261 20C11.3464 20 11.0326 19.7178 10.9829 19.3518L10.9761 19.25L10.9761 4.25C10.9761 3.83579 11.3119 3.5 11.7261 3.5C12.1058 3.5 12.4196 3.78215 12.4692 4.14823L12.4761 4.25L12.4761 19.25C12.4761 19.6642 12.1403 20 11.7261 20Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23296 10.829C5.9407 11.1225 5.46582 11.1235 5.1723 10.8313C4.90546 10.5656 4.88036 10.149 5.09758 9.85489L5.17002 9.77062L11.194 3.72062C11.4605 3.45298 11.8786 3.42863 12.1727 3.64759L12.2569 3.72057L18.2819 9.77057C18.5742 10.0641 18.5732 10.5389 18.2797 10.8312C18.0129 11.0969 17.5962 11.1203 17.303 10.9018L17.2191 10.829L11.7252 5.313L6.23296 10.829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.7ebb1378cbbb8070c285b15d16cf24df.svg";
export { ForwardRef as ReactComponent };